import apiSlice from "./ApiSlice";

const orderApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllOrderData: builder.query({
      providesTags: ["order"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/order/all-orders",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteOrderById: builder.mutation({
      invalidatesTags: ["order"],
      query: (id: any) => ({
        url: `/order/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addOrder: builder.mutation({
      invalidatesTags: ["order"],
      query: (body) => ({
        url: `/order/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getOrderById: builder.query({
      providesTags: ["order"],
      query: (id) => {
        return {
          url: `/order/admin/${id}`,
          method: "GET",
        };
      },
    }),
    getOrderReceiptDownloadById: builder.query({
      providesTags: ["order"],
      query: (id) => {
        return {
          url: `/order/download-receipt/${id}`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateOrderById: builder.mutation({
      invalidatesTags: ["order"],
      query: ({ body, id }) => ({
        url: `/order/${id}`,
        method: "PUT",
        body,
      }),
    }),

    //get all orders
    getAllOrders: builder.query({
      providesTags: ["order"],
      query: () => {
        return {
          url: `/order`,
          method: "GET",
        };
      },
    }),
    //get all orders
    getAllOrdersForExport: builder.query({
      providesTags: ["order"],
      query: () => {
        return {
          url: `/order/admin`,
          method: "GET",
        };
      },
    }),

    // change status of delivery date
    changeStatusOrderById: builder.mutation({
      invalidatesTags: ["order"],
      query: ({ body, id }) => ({
        url: `/order/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
    //update order status
    changeOrderStatusById: builder.mutation({
      invalidatesTags: ["order"],
      query: ({ body, id }) => ({
        url: `/order/update-status/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllOrderDataQuery,
  useGetOrderReceiptDownloadByIdQuery,
  useDeleteOrderByIdMutation,
  useAddOrderMutation,
  useGetOrderByIdQuery,
  useUpdateOrderByIdMutation,
  useGetAllOrdersQuery,
  useChangeStatusOrderByIdMutation,
  useChangeOrderStatusByIdMutation,
  useGetAllOrdersForExportQuery,
  useLazyGetAllOrdersForExportQuery,
} = orderApi;
